"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodePagePath = void 0;
var exchange_clients_commons_1 = require("@mulesoft/exchange-clients-commons");
var debug_1 = __importDefault(require("debug"));
var log = (0, debug_1.default)('exchange:page:service');
var encodePagePath = function (pagePath) {
    if (!pagePath) {
        return pagePath;
    }
    return pagePath
        .split('/')
        .map(function (path) { return encodeURIComponent(path); })
        .join('/');
};
exports.encodePagePath = encodePagePath;
var PageService = /** @class */ (function (_super) {
    __extends(PageService, _super);
    function PageService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getHTML = function (_a) {
            var context = _a.context, groupId = _a.groupId, assetId = _a.assetId, version = _a.version, pagePath = _a.pagePath, isDraft = _a.isDraft, domain = _a.domain, forwardedHost = _a.forwardedHost, forwardedPath = _a.forwardedPath;
            log("Getting ".concat(isDraft ? 'draft ' : '', "HTML for page ").concat(pagePath, ", asset ").concat(groupId, ":").concat(assetId, ":").concat(version));
            return _this.getPageText({
                groupId: groupId,
                assetId: assetId,
                version: version,
                pagePath: pagePath,
                contentType: 'html',
                isDraft: isDraft,
                context: context,
                domain: domain,
                forwardedHost: forwardedHost,
                forwardedPath: forwardedPath
            });
        };
        _this.getMarkdown = function (_a) {
            var context = _a.context, groupId = _a.groupId, assetId = _a.assetId, version = _a.version, pagePath = _a.pagePath, isDraft = _a.isDraft;
            log("Getting ".concat(isDraft ? 'draft ' : '', "Markdown for page ").concat(pagePath, ", asset ").concat(groupId, ":").concat(assetId, ":").concat(version), {
                context: context
            });
            return _this.getPageText({
                groupId: groupId,
                assetId: assetId,
                version: version,
                pagePath: pagePath,
                contentType: 'markdown',
                isDraft: isDraft,
                context: context
            });
        };
        _this.create = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var url, body, response, json;
            var context = _b.context, groupId = _b.groupId, assetId = _b.assetId, version = _b.version, pagePath = _b.pagePath;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = this.getAPIUrl({
                            context: context,
                            pathname: "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/").concat(version, "/portal/draft/pages")
                        });
                        body = JSON.stringify({ pagePath: pagePath });
                        log("Creating page ".concat(pagePath, ", asset ").concat(groupId, ":").concat(assetId, ":").concat(version), {
                            context: context
                        });
                        return [4 /*yield*/, this.fetch(url, { context: context, method: 'POST', body: body })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _c.sent();
                        return [2 /*return*/, json];
                }
            });
        }); };
        _this.rename = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var url, headers, response, json;
            var context = _b.context, groupId = _b.groupId, assetId = _b.assetId, version = _b.version, pagePath = _b.pagePath, oldPagePath = _b.oldPagePath;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        log("Renaming page ".concat(oldPagePath, " to ").concat(pagePath, ", asset ").concat(groupId, ":").concat(assetId, ":").concat(version));
                        url = this.getAPIUrl({
                            context: context,
                            pathname: "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/").concat(version, "/portal/draft/pages")
                        });
                        headers = { 'x-move-source': encodeURI(oldPagePath) };
                        return [4 /*yield*/, this.fetch(url, {
                                context: context,
                                headers: headers,
                                method: 'POST',
                                body: JSON.stringify({ pagePath: pagePath })
                            })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _c.sent();
                        return [2 /*return*/, json];
                }
            });
        }); };
        _this.remove = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var url;
            var context = _b.context, groupId = _b.groupId, assetId = _b.assetId, version = _b.version, pagePath = _b.pagePath;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        log("Removing page ".concat(pagePath, ", asset ").concat(groupId, ":").concat(assetId, ":").concat(version), {
                            context: context
                        });
                        url = this.getAPIUrl({
                            context: context,
                            pathname: "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/").concat(version, "/portal/draft/pages/").concat((0, exports.encodePagePath)(pagePath))
                        });
                        return [4 /*yield*/, this.fetch(url, { context: context, method: 'DELETE' })];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.orderPages = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var headers, url, body, response, newPagesOrderRevision;
            var context = _b.context, groupId = _b.groupId, assetId = _b.assetId, version = _b.version, pages = _b.pages, pagesOrderRevision = _b.pagesOrderRevision;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        log("Reordering pages, asset ".concat(groupId, ":").concat(assetId, ":").concat(version), {
                            pages: pages,
                            pagesOrderRevision: pagesOrderRevision,
                            context: context
                        });
                        headers = {};
                        url = this.getAPIUrl({
                            context: context,
                            pathname: "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/").concat(version, "/portal/draft/pagesOrder")
                        });
                        body = JSON.stringify(pages);
                        if (pagesOrderRevision) {
                            headers['x-pages-order-revision'] = pagesOrderRevision;
                        }
                        return [4 /*yield*/, this.fetch(url, {
                                context: context,
                                method: 'PUT',
                                body: body,
                                headers: headers
                            })];
                    case 1:
                        response = _c.sent();
                        newPagesOrderRevision = response.headers.get('x-pages-order-revision');
                        return [2 /*return*/, {
                                pagesOrderRevision: newPagesOrderRevision
                            }];
                }
            });
        }); };
        return _this;
    }
    PageService.prototype.upsert = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var pathname, url, headers, body;
            var context = _b.context, groupId = _b.groupId, assetId = _b.assetId, version = _b.version, pagePath = _b.pagePath, markdown = _b.markdown;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        log("Upserting page", {
                            groupId: groupId,
                            assetId: assetId,
                            version: version,
                            pagePath: pagePath,
                            markdown: markdown,
                            context: context
                        });
                        pathname = "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/").concat(version, "/portal/draft/pages/").concat((0, exports.encodePagePath)(pagePath));
                        url = this.getAPIUrl({
                            context: context,
                            pathname: pathname
                        });
                        headers = {
                            'Content-Type': 'text/markdown'
                        };
                        body = markdown;
                        return [4 /*yield*/, this.fetch(url, { context: context, headers: headers, method: 'PUT', body: body })];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PageService.prototype.getList = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var pathname, url, response, json;
            var context = _b.context, _c = _b.search, search = _c === void 0 ? '' : _c, groupId = _b.groupId, assetId = _b.assetId, minorVersion = _b.minorVersion;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        pathname = "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/minorVersions/").concat(minorVersion, "/portal/pages");
                        url = this.getAPIUrl({
                            context: context,
                            query: {
                                search: search
                            },
                            pathname: pathname
                        });
                        log('Getting pages list', {
                            search: search,
                            groupId: groupId,
                            assetId: assetId,
                            minorVersion: minorVersion
                        });
                        return [4 /*yield*/, this.fetch(url, { context: context })];
                    case 1:
                        response = _d.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _d.sent();
                        return [2 /*return*/, json];
                }
            });
        });
    };
    PageService.prototype.getPageText = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var url, headers, response, text, redirectPagePathValue, responseContentType, redirectPagePath;
            var context = _b.context, groupId = _b.groupId, assetId = _b.assetId, version = _b.version, _c = _b.pagePath, pagePath = _c === void 0 ? 'home' : _c, contentType = _b.contentType, isDraft = _b.isDraft, domain = _b.domain, forwardedHost = _b.forwardedHost, forwardedPath = _b.forwardedPath;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        url = this.getAPIUrl({
                            context: context,
                            pathname: "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/").concat(version, "/portal").concat(isDraft ? '/draft' : '', "/pages/").concat((0, exports.encodePagePath)(pagePath))
                        });
                        headers = {
                            Accept: "text/".concat(contentType)
                        };
                        if (domain) {
                            headers['X-Public-Portal-Domain'] = domain;
                        }
                        if (forwardedHost) {
                            headers['X-Forwarded-Host'] = forwardedHost;
                        }
                        if (forwardedPath) {
                            headers['X-Forwarded-Path'] = forwardedPath;
                        }
                        return [4 /*yield*/, this.fetch(url, {
                                context: context,
                                headers: headers,
                                redirect: 'manual'
                            })];
                    case 1:
                        response = _d.sent();
                        return [4 /*yield*/, response.text()];
                    case 2:
                        text = _d.sent();
                        redirectPagePathValue = response.headers.get('x-redirect-page');
                        responseContentType = response.headers.get('content-type');
                        redirectPagePath = redirectPagePathValue
                            ? decodeURIComponent(redirectPagePathValue)
                            : null;
                        return [2 /*return*/, { text: text, redirectPagePath: redirectPagePath, contentType: responseContentType }];
                }
            });
        });
    };
    return PageService;
}(exchange_clients_commons_1.BaseService));
exports.default = PageService;
